import { render, staticRenderFns } from "./WelcomePassword.vue?vue&type=template&id=b79576d8&scoped=true"
import script from "./WelcomePassword.vue?vue&type=script&lang=js"
export * from "./WelcomePassword.vue?vue&type=script&lang=js"
import style0 from "./WelcomePassword.vue?vue&type=style&index=0&id=b79576d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79576d8",
  null
  
)

export default component.exports